// extracted by mini-css-extract-plugin
export default {"tooltip":"xn-z","sharingV2":"yn-z","sharingIconsV2":"zn-z","links":"An-z","link":"Bn-z","facebookV2":"Cn-z","twitterV2":"Dn-z","pinterestV2":"En-z"};